module.exports = __webpack_public_path__ + "static/img/wycs01@2x.4b34b554.png";